import { Autocomplete, Paper, styled, TextField } from '@mui/material'
import { tokens } from 'ComponentLibrary/style-dictionary/output'
import { ComponentProps } from 'react'
import { CaretDown } from '../Select/Select'

type DropdownProps<Value, Multiple extends boolean | undefined = false> = Omit<
    ComponentProps<typeof Autocomplete<Value, Multiple>>,
    'renderInput'
> & { label: string; required?: boolean }

/**
 * @deprecated Use `Dropdown` from the Piazza component library for new work.
 */
export function Dropdown<Value, Multiple extends boolean | undefined = false>({
    label,
    required = false,
    ...autocompleteProps
}: DropdownProps<Value, Multiple>) {
    return (
        <Autocomplete
            PaperComponent={(props) => <StyledPopper {...props} />}
            renderInput={(params) => (
                <TextField sx={{ '& label': { paddingRight: tokens.SizingIconM } }} {...params} required={required} label={label} />
            )}
            popupIcon={<CaretDown />}
            {...autocompleteProps}
        />
    )
}

const StyledPopper = styled(Paper)`
    margin-top: ${tokens.SizingSpacing100};
`
